// Updated Navigation.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';

function Navigation({ user, handleLogout }) {
  const [menuOpen, setMenuOpen] = useState(false);
  
  // Mobile-optimized button style
  const mobileButtonStyle = {
    fontSize: '16px',
    fontWeight: '600',
    height: '56px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '8px',
    border: 'none',
    padding: '0 20px',
    appearance: 'none',
    cursor: 'pointer'
  };
  
  const primaryButtonStyle = {
    ...mobileButtonStyle,
    backgroundColor: '#ffffff',
    color: '#2563eb',
  };
  
  const linkStyle = {
    fontSize: '16px',
    fontWeight: '500',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '56px',
    padding: '0 20px',
    color: '#ffffff',
    textDecoration: 'none'
  };
  
  return (
    <div className="bg-blue-600 text-white">
      {/* Logo in its own centered container */}
      <div className="flex justify-center py-4">
        <Link to="/">
          <Logo className="h-12 w-auto" />
        </Link>
      </div>
      
      {/* Navigation bar */}
      <nav className="border-t border-blue-500">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center h-16">
            {/* Left side navigation links */}
            <div className="flex items-center">
              {/* Mobile menu button */}
              <button 
                onClick={() => setMenuOpen(!menuOpen)}
                className="md:hidden flex items-center justify-center text-white p-2"
                style={{
                  height: '44px',
                  width: '44px',
                  background: 'transparent',
                  border: 'none'
                }}
                aria-label={menuOpen ? "Close menu" : "Open menu"}
              >
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  width="28" 
                  height="28" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                >
                  {menuOpen ? (
                    <>
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </>
                  ) : (
                    <>
                      <line x1="3" y1="12" x2="21" y2="12"></line>
                      <line x1="3" y1="6" x2="21" y2="6"></line>
                      <line x1="3" y1="18" x2="21" y2="18"></line>
                    </>
                  )}
                </svg>
              </button>
              
              {/* Desktop navigation links */}
              <div className="hidden md:flex items-center">
                <Link to="/" className="text-white mr-6">
                  Home
                </Link>
                
                {user && (
                  <Link to="/documents" className="text-white">
                    My Documents
                  </Link>
                )}
              </div>
            </div>
            
            {/* Center for mobile */}
            <div className="md:hidden flex-grow text-center">
              <span className="text-lg font-semibold">
                Waka
              </span>
            </div>
            
            {/* Right side - User actions */}
            <div className="flex items-center">
              {/* Desktop user menu */}
              <div className="hidden md:flex items-center">
                {user ? (
                  <div className="flex items-center">
                    <span className="mr-4 text-white">Hello, {user.email}</span>
                    <button 
                      onClick={handleLogout}
                      style={primaryButtonStyle}
                      className="hover:bg-gray-100"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                      </svg>
                      Logout
                    </button>
                  </div>
                ) : (
                  <div className="flex items-center">
                    <Link 
                      to="/" 
                      style={linkStyle} 
                      className="hover:underline invisible"
                    >
                      Home
                    </Link>
                  </div>
                )}
              </div>
              
              {/* Mobile user menu button */}
              <div className="md:hidden flex">
                {user ? (
                  <button
                    onClick={handleLogout}
                    className="p-2 text-white"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                    </svg>
                  </button>
                ) : (
                  <div className="invisible p-2 text-white">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
                    </svg>
                  </div>
                )}
              </div>
            </div>
          </div>
          
          {/* Mobile menu */}
          {menuOpen && (
            <div className="md:hidden pt-4 pb-4 border-t border-blue-500">
              <div className="flex flex-col gap-3">
                <Link 
                  to="/"
                  className="text-white text-center py-3 rounded-md text-lg"
                  onClick={() => setMenuOpen(false)}
                >
                  Home
                </Link>
                
                {user && (
                  <Link 
                    to="/documents"
                    className="bg-blue-700 text-white text-center py-3 rounded-md text-lg"
                    onClick={() => setMenuOpen(false)}
                  >
                    My Documents
                  </Link>
                )}
                
                {user && (
                  <div className="mt-3 pt-3 border-t border-blue-500">
                    <div className="text-center py-2 mb-3 text-lg font-medium">
                      Hello, {user.email}
                    </div>
                    <button 
                      onClick={() => {
                        handleLogout();
                        setMenuOpen(false);
                      }}
                      style={{
                        ...primaryButtonStyle,
                        width: '100%',
                        fontSize: '18px'
                      }}
                      className="hover:bg-gray-100"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                      </svg>
                      Logout
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </nav>
    </div>
  );
}

export default Navigation;